import React from 'react';
import { View, StyleSheet } from 'react-native';
import Text from 'design-system/Text';
import Squircle from 'design-system/Squircle';
import { CardView, Spacer, rem } from 'design-system';
import IconTicketSolid from 'design-system/icons/IconTicketSolid';
import useColors from 'hooks/useColors';
const InsightsEmptyComponent = () => {
    const colors = useColors();
    return (<CardView style={styles.cardView}>
      <View style={styles.container}>
        <Squircle width={rem(64)} height={rem(64)} color={colors.background.dark}>
          <IconTicketSolid colorKey="brand" width={32} height={32}/>
        </Squircle>
        <Spacer h={16}/>
        <Text Text-16 centered>
          Discover your first stock
        </Text>
        <Spacer h={4}/>
        <Text TextThin-16 centered Secondary>
          {'Invest as little as £1 in your favourite\xa0companies.\xa0Capital\xa0at\xa0Risk'}
        </Text>
      </View>
    </CardView>);
};
export default InsightsEmptyComponent;
const styles = StyleSheet.create({
    container: {
        alignItems: 'center',
    },
    cardView: {
        padding: rem(24),
    },
});
